import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OperatoriComponent } from './operatori.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { EditOperatorComponent } from './edit-operator/edit-operator.component';
import { UpdateFunctieOperatorComponent } from './update-functie-operator/update-functie-operator.component';

@NgModule({
  declarations: [OperatoriComponent, EditOperatorComponent, UpdateFunctieOperatorComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule],
  exports: [OperatoriComponent],
})
export class OperatoriModule {}
